import { useTranslation } from "react-i18next";
import IconButton from "./IconButton";

const PaginationControls = ({
    previous,
    next,
    goToFirstPage,
    hasNextPage,
    currentPage,
    totalPages,
    isLoading = false
}) => {
    const [translate] = useTranslation();

    return <>
        {goToFirstPage && <IconButton
            name="SkipNext"
            title={translate("OTM_GO_TO_FIRST_PAGE")}
            onClick={goToFirstPage}
            disabled={currentPage === 1 || isLoading}
            variant="primary"
            highlight={true}
            iconProps={{ style: { transform: "rotateZ(180deg)" } }}
        />}
        <IconButton
            name="ChevronLeft"
            title={translate("OTM_PREVIOUS")}
            onClick={previous}
            disabled={currentPage === 1 || isLoading}
            variant="primary"
            highlight={true}
        />
        <span style={{ whiteSpace: "nowrap" }}>
            {totalPages > 0 ? currentPage : 0} / {totalPages}
        </span>       
        <IconButton
            name="ChevronRight"
            title={translate("OTM_NEXT")}
            onClick={next}
            disabled={!hasNextPage || isLoading}
            variant="primary"
            highlight={true}
            buttonClassName="ms-1"
        />
    </>
}

export default PaginationControls;